import { render, staticRenderFns } from "./XR.vue?vue&type=template&id=ab5123c6&scoped=true&"
import script from "./XR.vue?vue&type=script&lang=js&"
export * from "./XR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5123c6",
  null
  
)

export default component.exports